export default __webpack_public_path__ + "static/media/xp-coffee-b.402c4174.svg";